import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  IconButton,
  Box,
  Link as MUILink,
  Popover,
  Divider,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";

import { navMenu, ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

// import Cart from "../Cart";
import HeaderButtons from "../HeaderButtons";
import Logo from "@/components/UI-Kit/Logo";
import Submenu from "./Submenu";
import { mobileLinkStyles, mobileMenuStyles, popoverStyles } from "./styles";
import Cart from "../Cart";

const MobileMenu = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");
  const isDesktop = useResponsive("up", "lg");
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null); // Mobile menu pop up state
  const [activeSubMenu, setActiveSubMenu] = useState<null | string>(null); // Accordion sub menu state

  // Toggle the accordion state
  const toggleAccordionMenu = (path: string) => {
    if (activeSubMenu === path) {
      setActiveSubMenu(null);
    } else {
      setActiveSubMenu(path);
    }
  };

  // Toggle nav burger mobile menu state
  const toggleNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (!anchorElNav) {
      setAnchorElNav(event.currentTarget);
    } else {
      closeMobileMenu();
    }
  };

  // Close mobile menu
  const closeMobileMenu = () => {
    setAnchorElNav(null);
    setActiveSubMenu(null);
  };

  return (
    <>
      {/* Mobile burger button */}
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        <IconButton
          size="large"
          aria-label="mobile menu appbar"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={toggleNavMenu}
          color="inherit"
        >
          {anchorElNav ? <CloseIcon /> : <MenuIcon />}
        </IconButton>

        {/* Mobile dropdown menu */}
        <Popover
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          keepMounted
          open={Boolean(anchorElNav)}
          onClose={toggleNavMenu}
          sx={popoverStyles}
          PaperProps={mobileMenuStyles}
        >
          {/* Nav links */}
          <Box>
            {navMenu.map(({ path, title, submenu }) => (
              <Box key={path}>
                {submenu ? (
                  <Submenu
                    key={path}
                    summary={title}
                    path={path}
                    activeSubMenu={activeSubMenu}
                    toggleAccordionMenu={toggleAccordionMenu}
                    closeNavMenu={closeMobileMenu}
                  />
                ) : (
                  <MUILink
                    component={Link}
                    to={path}
                    onClick={toggleNavMenu}
                    sx={{
                      ...mobileLinkStyles,
                      color:
                        pathname === path
                          ? theme.palette.primary.main
                          : theme.palette.grey[800],
                    }}
                  >
                    {title}
                  </MUILink>
                )}
              </Box>
            ))}

            <Box>
              <MUILink
                component={Link}
                to={ROUTES.findDealer}
                onClick={toggleNavMenu}
                sx={{
                  ...mobileLinkStyles,
                  color:
                    pathname === ROUTES.findDealer
                      ? theme.palette.primary.main
                      : theme.palette.grey[800],
                }}
              >
                Find Installers
              </MUILink>
            </Box>
          </Box>

          {/* Nav buttons */}
          <Box>
            <Divider sx={{ mb: 3 }} />
            <HeaderButtons />
          </Box>
        </Popover>
      </Box>

      {/* Logo */}
      <Box
        sx={{
          display: { xs: "flex", lg: "none" },
          paddingY: { xs: 2.5, sm: 0 },
        }}
      >
        <Logo
          type="dark"
          width={isMobile ? 132 : 204}
          height={isMobile ? 25 : 38}
        />
      </Box>

      {/* Cart */}
      {!isDesktop && <Cart />}
      {/*{!isDesktop && <div style={{ width: '20px', padding: '12px' }}/>}*/}
    </>
  );
};

export default MobileMenu;
